<template>
  <!-- Footer -->
  <footer class="footer">
    <div class="container">
     
      <!-- Footer Top -->
      <div class="footer-top">
        <div class="row">
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h4 class="footer-title">Thông tin liên hệ</h4>
              <div class="footer-address-blk">
                <div class="footer-call">
                  <p>0914.616.818</p>
                </div>
                <div class="footer-call">
                  <p>ezcaulong@gmail.com</p>
                </div>
              </div>
              <div class="social-icon">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/ezbadmintonHP/about" target="_blank" class="facebook"><i class="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="twitter"><i class="fab fa-twitter"></i> </a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="instagram"><i class="fab fa-instagram"></i></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="linked-in"><i class="fab fa-linkedin-in"></i></a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h4 class="footer-title">Menu</h4>
              <ul>
                <li>
                  <router-link to="/trang-chu">Trang chủ</router-link>
                </li>
                <li>
                  <router-link to="/giai-dau">Giải đấu</router-link>
                </li>
                <li>
                  <router-link to="/xep-hang">Xếp hạng</router-link>
                </li>
                <li>
                  <router-link to="/tin-tuc">Tin tức</router-link>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h4 class="footer-title">Hỗ trợ</h4>
              <ul>
                <li>
                  <router-link to="/lien-he">Liên hệ</router-link>
                </li>
                <li>
                  <router-link v-if="!authStore.user" to="/register">Đăng ký</router-link>
                </li>
                <li>
                  <router-link to="/user/sua-thong-tin">Tài khoản</router-link>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h4 class="footer-title">Liên kết</h4>
              <ul>
                <li>
                  <a href="https://ezb.com.vn/"  target="_blank" >Cửa hàng EZB</a>
                </li>
                <li>
                  <a href="https://bwfbadminton.com/"  target="_blank" >BWF</a>
                </li>
                <li>
                  <a href="https://www.vnbadminton.com/"  target="_blank" >Cầu lông Việt Nam</a>
                </li>
                <li>
                  <a href="https://www.olympics.com/ioc/badminton-world-federation"  target="_blank" >Olympics</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>        
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <!-- Copyright -->
        <div class="copyright">
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="copyright-text">
                <p class="mb-0">Bản quyền &copy;  {{ new Date().getFullYear() }} EZBadminton - Hỗ trợ bởi 
                  <a href="https://absoltech.vn/" target="_blank" rel="noopener noreferrer">
                    ABSoltech
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- /Copyright -->
      </div>
    </div>
    <!-- /Footer Bottom -->
  </footer>
  <!-- /Footer -->
</template>

<script>
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    const authStore = useAuthStore();
    return {
      authStore,
      Language: ["English (US)", "UK", "Japan"],
      Doller: ["$ USD", "$ Euro"],
    };
  },
};
</script>
